/**
 * ScrollIndicator — subtle visual cue when content continues below fold.
 * Shows a bouncing dot+line in Stone colour. Hides once user scrolls.
 */
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollIndicator() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const check = () => {
      const scrollable = document.documentElement.scrollHeight > window.innerHeight + 60;
      const nearBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 80;
      setVisible(scrollable && !nearBottom && window.scrollY < 100);
    };
    // Reset on route change
    setVisible(false);
    const timer = setTimeout(check, 300);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
      clearTimeout(timer);
    };
  }, [location.pathname]);

  // Hide on admin pages and hero (dark backgrounds where Stone is invisible)
  const hideOnPaths = ['/admin'];
  const isHidden = hideOnPaths.some(p => location.pathname.startsWith(p));

  return isHidden ? null : (
    <div className={`scroll-indicator ${visible ? '' : 'hidden'}`} data-testid="scroll-indicator" aria-hidden="true">
      <div className="scroll-indicator-line" />
      <div className="scroll-indicator-dot" />
    </div>
  );
}
